module.exports = __webpack_public_path__ + "img/white_location.955fc064.svg";